// m:ss, or h:mm:ss from an hour up. Fractions of a second are dropped.
export function formatDuration(seconds) {
  const total = Math.max(0, Math.floor(Number.isFinite(seconds) ? seconds : 0));
  return clock(total);
}

// Remaining time as "-1:19". At the end it is "0:00", never "-0:00".
export function formatRemaining(position, duration) {
  const remaining = Math.max(0, Math.ceil(duration - position));
  const body = clock(remaining);
  return remaining === 0 ? body : `-${body}`;
}

function clock(total) {
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = String(total % 60).padStart(2, "0");
  return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${s}` : `${m}:${s}`;
}
